import React, {useState} from 'react';

import { resetPassword } from 'actions';
import useActions from 'hooks/useActions';
import PublicPage from 'components/PublicPage';
import { default as PasswordForgottenForm } from 'forms/PasswordForgotten';


const PasswordForgotten = ({navbarProps}) => {
  const [passwordReseted, setPasswordReseted] = useState(false);
  const dispatchPasswordForgotten = useActions(resetPassword);
  const onSuccess = () => {
    setPasswordReseted(true)
  };
  const onSubmit = (values) => {
    dispatchPasswordForgotten(values, {onSuccess});
  }
  return (
    <PublicPage navbarProps={navbarProps}>
      <div className="container py-6">
        <div className="box my-6">
          {!passwordReseted ?
            <PasswordForgottenForm onSubmit={onSubmit} />
            :
            <div className="content">
              <p>Un lien pour réinitialiser votre mot de passe a été envoyé par email</p>
            </div>
          }
        </div>
      </div>
    </PublicPage>
  )
}

export default PasswordForgotten;